
import { Vue } from "vue-class-component";

export default class FileUpload extends Vue {}
